import { Component, Input, Output, EventEmitter, ViewEncapsulation } from '@angular/core';
import { Profile } from '../../../core/models/profile';
import { EnvironmentService } from 'src/app/core/enviroment/environment.service';

@Component({
  selector: 'app-profile-card',
  templateUrl: './profile-card.component.html',
  styleUrls: ['./profile-card.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ProfileCardComponent {

  @Input()
  public isModal = false;

  @Input()
  public dataForm?: Profile;

  @Output()
  public send = new EventEmitter<boolean>();

  public profileDefault = 'https://bucketsquadcrm.s3.amazonaws.com/default_images/profile_default.jpg';

  public displayShareDropdown: boolean;
  private uri = this.environmentService.getEnvVar('api_share');

  public url = `${window.location.host}`;

  constructor(private environmentService: EnvironmentService) { }

  public toggleShareDropdown() {
    this.displayShareDropdown = !this.displayShareDropdown;
  }

  shareOnWhatsapp() {
    this.displayShareDropdown = false;
    window.open(`https://api.whatsapp.com/send?text=${this.uri}${this.dataForm.nickname}`, '_blank');
  }

  shareOnFacebook() {
    this.displayShareDropdown = false;
    const encodedURL = encodeURIComponent(`${this.uri}${this.dataForm.nickname}`);
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${encodedURL}`, '_blank');
  }

  shareOnLinkedin() {
    this.displayShareDropdown = false;
    const encodedURL = encodeURIComponent(`${this.uri}${this.dataForm.nickname}`);
    window.open(`https://www.linkedin.com/shareArticle?mini=true&url=${encodedURL}`, '_blank');
  }

}
